import { render, staticRenderFns } from "./scroheader.vue?vue&type=template&id=51e6233e&scoped=true"
import script from "./scroheader.vue?vue&type=script&lang=js"
export * from "./scroheader.vue?vue&type=script&lang=js"
import style0 from "./scroheader.vue?vue&type=style&index=0&id=51e6233e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6233e",
  null
  
)

export default component.exports